import {
  Close,
  Cupom,
  IconCreditCard,
  IconPix,
  IconSecurity,
  IconTicketPayment,
} from '@/assets/icons';
import { Button, Modal } from '@/components';
import { defaultModalTheme, pixTheme } from '@/components/Modal/modalTheme';
import { TabTypePayments } from '@/components/TabTypePayments';
import { CreditCardC6PaymentRequestContent } from '@/features/checkout/components/CreditCardC6PaymentRequestContent';
import { CreditCardPaymentContent } from '@/features/checkout/components/CreditCardPaymentContent';
import { CreditCardPaymentRequestContent } from '@/features/checkout/components/CreditCardPaymentRequestContent';
import { NoCardContent } from '@/features/checkout/components/NoCardContent';
import { PaymentErroContent } from '@/features/checkout/components/PaymentError';
import { PaymentNotMadeContent } from '@/features/checkout/components/PaymentNotMade';
import { PixPaymentContent } from '@/features/checkout/components/PixPaymentContent';
import { TicketPaymentContent } from '@/features/checkout/components/TicketPaymentContent';
import { CardCheckout, ShowModalPayment } from '@/features/checkout/types';
import { TicketIncrementResume } from '@/features/core/auth/components/TicketIncrementResume';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';
import Cart from '@/features/core/cart/components/Cart';
import { EventTicketSite } from '@/features/event/screens/Event';
import { ConfirmDeleteCreditCardContent } from '@/features/profile/components/ConfirmDeleteCreditCardContent';
import { classNames } from '@/helpers/common';
import CardClient from '@/model/CardClient';
import Payment from '@/model/Payment';
import PaymentType from '@/model/PaymentType';
import dayjs from 'dayjs';
import React, { ReactNode, useEffect, useState } from 'react';

interface PaymentTab {
  text: string;
  icon: React.ReactNode;
  type: PaymentType;
}

interface PaymentContent {
  content: React.ReactNode;
  type: PaymentType;
}
interface PaymentTabAndContent {
  tabs: PaymentTab[];
  contents: PaymentContent[];
}

interface StateProps {
  cart: Cart;
  payment: Payment;
  paymentType?: PaymentType;
  card?: CardCheckout;
  c6CreditCheckout: boolean;
  cards: CardClient[];
  cameFromAdm: boolean;
  visible: boolean;
  title: ReactNode | string;
  shouldShowModal: ShowModalPayment;
  boleto: string;
  barcode: string;
  qrCodeImage: string;
  qrCodeText: string;
  messageError?: string;
  messagePayment?: string;
}
interface DispatchProps {
  toCurrency: (value: number) => string;
  onChangeCreditCard: (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  onCardSelected: (id: string) => void;
  onShowDeleteCreditCard: (id: string) => void;
  checkoutValidateCreditCard: () => void;
  onAddCard: () => void;
  onIncrementTicket: (item: EventTicketSite) => void;
  onDecrementTicket: (item: EventTicketSite) => void;
  onRemoveCupom: () => void;
  onSetPaymentType: (type: PaymentType) => void;
  onSendOrder: () => void;
  onToggle: () => void;
  onGoToTickets: () => void;
  onCopyText: (text: string) => void;
  onDeleteCreditCard: () => void;
}

type CheckoutContainerProps = StateProps & DispatchProps;

export const CheckoutContainer: React.FC<CheckoutContainerProps> = ({
  cart,
  toCurrency,
  payment,
  paymentType,
  card,
  c6CreditCheckout,
  onChangeCreditCard,
  cards,
  onCardSelected,
  onShowDeleteCreditCard,
  onDeleteCreditCard,
  checkoutValidateCreditCard,
  onAddCard,
  cameFromAdm,
  onIncrementTicket,
  onDecrementTicket,
  onRemoveCupom,
  onSetPaymentType,
  onSendOrder,
  visible,
  title,
  onToggle,
  shouldShowModal,
  onGoToTickets,
  boleto,
  barcode,
  onCopyText,
  qrCodeImage,
  qrCodeText,
  messageError,
  messagePayment,
}) => {
  const [paymentTabAndContent, setPaymentTabAndContent] = useState<PaymentTabAndContent>({
    tabs: [],
    contents: [],
  });
  const mountTotalValue = (): string => {
    let value = cart.totalValueWithFee;
    if (cart.fractional) {
      value = cart.fractional.remainingValue;
    } else if (cart.discountCoupon) {
      value -= cart.discountCoupon.discount;
    } else if (cart.voucher) {
      value -= cart.voucher.value;
    }
    return toCurrency(value);
  };

  const mountPayment = (): void => {
    const tabsAndContents: PaymentTabAndContent = {
      tabs: [],
      contents: [],
    };
    if (payment && payment.fees) {
      if (payment.allowPaymentCredit) {
        tabsAndContents.tabs.push({
          text: 'Cartão de Crédito',
          icon: (
            <IconCreditCard
              className={classNames(
                paymentType === PaymentType.CREDIT_CARD ? 'text-white' : 'text-neutro-w-600',
                'mb-[16px] h-[15px]',
              )}
            />
          ),
          type: PaymentType.CREDIT_CARD,
        });
        tabsAndContents.contents.push({
          content: (
            <div key={1} className="mt-[50px]">
              <div className="flex">
                <IconCreditCard
                  className={classNames(
                    paymentType === PaymentType.CREDIT_CARD ? 'text-black' : 'text-neutro-w-600',
                    'mt-[10px] h-[20px]',
                  )}
                />
                <h1 className="ml-[10px] font-dmsans font-normal text-neutro-b-400 text-[28px] mb-[10px ]">
                  {card && c6CreditCheckout ? (
                    <span>Informe a Parcela</span>
                  ) : (
                    <span>Selecione o cartão</span>
                  )}
                </h1>
              </div>

              {card && c6CreditCheckout && (
                <CreditCardC6PaymentRequestContent
                  payment={payment}
                  totalValue={cart.originalValueWithPaymentFee}
                  toCurrency={toCurrency}
                  onChange={onChangeCreditCard}
                  card={card}
                />
              )}

              {card && !c6CreditCheckout && (
                <CreditCardPaymentRequestContent
                  cards={cards}
                  payment={payment}
                  totalValue={cart.originalValueWithPaymentFee}
                  toCurrency={toCurrency}
                  card={card}
                  onCardSelected={onCardSelected}
                  onShowDeleteCreditCard={onShowDeleteCreditCard}
                  onChange={onChangeCreditCard}
                  validateCreditCard={checkoutValidateCreditCard}
                />
              )}
              {!c6CreditCheckout && (
                <Button
                  type="button"
                  title="+ Adicionar novo cartão"
                  buttonStyle="dashed"
                  size="xlg"
                  className="mt-[40px] w-full lg:w-[411px]"
                  onClick={onAddCard}
                />
              )}
            </div>
          ),
          type: PaymentType.CREDIT_CARD,
        });
      }

      if (payment.allowPaymentBankSlip) {
        tabsAndContents.tabs.push({
          text: 'Boleto',
          icon: (
            <IconTicketPayment
              className={classNames(
                paymentType === PaymentType.BANK_SLIP ? 'text-white' : 'text-neutro-w-600',
                'mb-[16px] h-[22px]',
              )}
            />
          ),
          type: PaymentType.BANK_SLIP,
        });

        tabsAndContents.contents.push({
          content: (
            <div key={3} className="md:w-[470px] mt-[50px]">
              <IconTicketPayment className="text-neutro-b-400 h-[36px] mb-[25px]" />
              <h4 className="font-dmsans font-bold text-neutro-b-400 text-base mb-[25px]">
                O ingresso já é quase seu!
              </h4>
              <p className="font-dmsans text-base font-normal text-neutro-w-600 mb-[40px]">
                Ao clicar em <strong>“Finalizar compra”</strong>, o boleto aparecerá na tela e você
                terá 3 dias para efetuar o pagamento.
              </p>
              <div className="flex justify-start items-center">
                <div className="w-[26px] h-[5px] bg-neutro-w-600 mr-2"></div>
                <IconSecurity className="text-neutro-w-600 h-[15px]" />
              </div>
              <p className="font-dmsans text-base font-normal text-neutro-w-600">
                Pagamento 110% Seguro
              </p>
            </div>
          ),
          type: PaymentType.BANK_SLIP,
        });
      }

      if (payment.allowPaymentPIX) {
        tabsAndContents.tabs.push({
          text: 'PIX',
          icon: (
            <IconPix
              className={classNames(
                paymentType === PaymentType.PIX ? 'text-white' : 'text-neutro-w-600',
                'mb-[16px] h-[20px]',
              )}
            />
          ),
          type: PaymentType.PIX,
        });

        tabsAndContents.contents.push({
          content: (
            <div key={4} className="md:w-[411px] mt-[50px]">
              <IconPix className="text-neutro-b-400 h-[36px] mb-[25px]" />
              <h4 className="font-dmsans font-bold text-neutro-b-400 text-base mb-[25px]">
                O ingresso já é quase seu!
              </h4>
              <p className="font-dmsans text-base font-normal text-neutro-w-600 mb-[40px]">
                Ao clicar em <strong>“Finalizar compra”</strong>, o código PIX aparecerá na tela
                para você poder fazer o pagamento instantâneo.
              </p>
              <div className="flex justify-start items-center">
                <div className="w-[26px] h-[5px] bg-neutro-w-600 mr-2"></div>
                <IconSecurity className="text-neutro-w-600 h-[15px]" />
              </div>
              <p className="font-dmsans text-base font-normal text-neutro-w-600">
                Pagamento 110% Seguro
              </p>
            </div>
          ),
          type: PaymentType.PIX,
        });
      }
      setPaymentTabAndContent(tabsAndContents);
    }
  };

  useEffect(() => {
    if (payment) {
      mountPayment();
    }
  }, [payment]);

  useEffect(() => {
    if (card) {
      mountPayment();
    }
  }, [card]);

  useEffect(() => {
    setTimeout(() => {
      const element = window.document.getElementById('selectPrincipal') as HTMLElement;
      element.scrollIntoView();
    }, 200);
  }, []);

  return (
    <AuthWrapper isHomepage={false}>
      <div
        className="w-full container mx-auto"
        style={{ paddingTop: '20px', paddingBottom: '6rem' }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <section
            className="mb-[20px] ml-[10px] md:shadow-xs sm:p-[15px] p-[0]"
            id="selectPrincipal"
            // style={{ borderRight: '1px solid rgba(128, 128, 128, 0.1)' }}
          >
            <h2 className="font-dmsans font-normal text-neutro-b-400 text-[28px] ">
              <span className="font-bold">1.</span> Confira seu pedido
            </h2>
            <p className="font-dmsans text-base font-normal text-neutro-w-600 leading-[28px]">
              Confirme se o seu pedido esta correto
            </p>
            <div className="md:w-[481px]">
              {cart.events.map(event => (
                <div
                  key={event.id}
                  style={{ paddingTop: '10px' }}
                  className=" cart-item w-full border-b border-neutro-w-200"
                >
                  <header className="grid grid-cols-[115px_1fr] items-center gap-5">
                    <div className="relative">
                      <img
                        className="w-[115px] rounded-md"
                        src={event.imageDetailUrl}
                        alt="Event"
                      />
                      <div className="absolute rounded-md top-0 w-full h-full bg-card-default hover:bg-card-hover transition-all duration-200 ease-in-out"></div>
                    </div>
                    <div className="text-left">
                      <h4 className="text-neutral-b-400 font-dmsans font-medium text-[18px] sm:text-[21px]">
                        {event.name}
                      </h4>
                      <div className="flex items-center text-base ">
                        <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                          {dayjs(event.startDate).locale('pt-br').format('DD MMM')}{' '}
                        </span>
                        <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full"></span>
                        <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                          {dayjs(event.startDate).format('HH:mm')}
                        </span>
                        <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full text-[12px] sm:text-[18px]"></span>
                        <span className="font-dmsans font-normal text-neutro-w-600">
                          {event.address.city}/{event.address.state}
                        </span>
                      </div>
                    </div>
                  </header>
                  <div>
                    <>
                      {event.sections &&
                        event.sections.length > 0 &&
                        event.sections.map(section => (
                          <div key={`empty-tag-${section.section.id}`}>
                            {section.tickets &&
                              section.tickets.length > 0 &&
                              section.tickets.map(ticket => (
                                <TicketIncrementResume
                                  key={ticket.id + ticket.isHalfPrice}
                                  item={ticket}
                                  cameFromAdm={cameFromAdm}
                                  increment={onIncrementTicket}
                                  decrement={onDecrementTicket}
                                />
                              ))}
                          </div>
                        ))}
                    </>
                  </div>
                </div>
              ))}
            </div>
            <div className="md:w-[481px] text-left">
              <div className="mb-[20px]">
                {cart.discountCoupon && (
                  <div className="flex justify-between items-center mt-5">
                    <div className="flex justify-start items-center">
                      <img src={Cupom} alt={cart.discountCoupon.name} />
                      <span className="uppercase ml-3 mr-12">{cart.discountCoupon.code}</span>
                    </div>
                    <a onClick={() => onRemoveCupom()} className="text-neutro-b-400 cursor-pointer">
                      <img src={Close} alt="fechar" className="fill-neutro-b-400" />
                    </a>
                  </div>
                )}
                {cart.voucher && (
                  <div className="flex justify-between items-center mt-5">
                    <div className="flex justify-start items-center">
                      <img src={Cupom} alt={cart.voucher.code} />
                      <span className="uppercase ml-3 mr-12">{cart.voucher.code}</span>
                    </div>
                    <a onClick={() => onRemoveCupom()} className="text-neutro-b-400 cursor-pointer">
                      <img src={Close} alt="fechar" className="fill-neutro-b-400" />
                    </a>
                  </div>
                )}
              </div>
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Total de itens: <span className="font-bold">{cart.amountItens}</span>
                </div>
              </div>

              {cart.fractional?.allowFractionalPayment && (
                <>
                  <div className="flex justify-between items-center mb-1">
                    <div className="text-heading font-dmsans font-normal">
                      Total:{' '}
                      <span className="font-bold">
                        {toCurrency(cart.originalValueWithPaymentFee)}
                      </span>
                    </div>
                    <div className="text-heading font-dmsans font-normal">
                      Pago:{' '}
                      <span className="font-bold">{toCurrency(cart.fractional.paidAmount)}</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <div className="text-heading font-dmsans font-normal">
                      Restante:{' '}
                      <span className="font-bold">
                        {toCurrency(cart.fractional.remainingValue)}
                      </span>
                    </div>
                  </div>
                </>
              )}
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Sub total:{' '}
                  <span className="font-bold">
                    {cart.fractional
                      ? toCurrency(cart.fractional.remainingValue)
                      : toCurrency(cart.totalValue)}
                  </span>
                </div>
              </div>
              {cart.discountCoupon && (
                <div className="flex justify-between items-center mb-1">
                  <div className="text-heading font-dmsans font-normal">
                    Desconto:{' '}
                    <span className="font-bold">- {toCurrency(cart.discountCoupon.discount)}</span>
                  </div>
                </div>
              )}
              {cart.voucher && (
                <div className="flex justify-between items-center mb-1">
                  <div className="text-heading font-dmsans font-normal">
                    Desconto: <span className="font-bold">- {toCurrency(cart.voucher.value)}</span>
                  </div>
                </div>
              )}
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Taxa:{' '}
                  <span className="font-bold">
                    {toCurrency(cart.totalValueWithFee - cart.totalValue)}
                  </span>
                </div>
              </div>
              <hr className="my-5" />
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Valor total: <span className="font-bold">{mountTotalValue()}</span>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-[20px] ml-[10px] md:shadow-xs sm:p-[15px] p-[0]">
            <h2 className="font-dmsans font-normal text-neutro-b-400 text-[28px]">
              <span className="font-bold">2.</span>
              Escolha a forma de pagamento
            </h2>
            <p className="font-dmsans text-base font-normal text-neutro-w-600 leading-[28px]">
              Selecione abaixo a sua forma de pagamento
            </p>
            <div className="mt-[20px]">
              <TabTypePayments
                typePayment={paymentType}
                onSetTypePayment={onSetPaymentType}
                tabs={paymentTabAndContent.tabs}
                contents={paymentTabAndContent.contents}
              />
              <div className="md:w-[500px] mt-[70px]">
                <Button
                  type="submit"
                  title={`Finalizar compra de ${toCurrency(cart.totalValueWithPaymentFee)}`}
                  buttonStyle="primary"
                  size="xlg"
                  className="w-full mb-[25px]"
                  onClick={onSendOrder}
                  disabled={paymentType === undefined}
                />
              </div>
            </div>
          </section>
        </div>
        <Modal
          visible={visible}
          title={title}
          onSetVisible={onToggle}
          actions={[]}
          theme={ShowModalPayment.PIX_PAYMENT ? pixTheme : defaultModalTheme}
          className={ShowModalPayment.PIX_PAYMENT ? 'md:w-[1360px]' : 'md:w-[750px]'}
          showCloseButton={true}
        >
          {
            {
              [ShowModalPayment.CREDIT_CARD_PAYMENT]: (
                <CreditCardPaymentContent onGoToTickets={onGoToTickets} />
              ),
              [ShowModalPayment.TICKET_PAYMENT]: (
                <TicketPaymentContent boleto={boleto} barcode={barcode} onCopyText={onCopyText} />
              ),
              [ShowModalPayment.PIX_PAYMENT]: (
                <PixPaymentContent
                  qrCodeImage={qrCodeImage}
                  qrCodeText={qrCodeText}
                  onCopyText={onCopyText}
                />
              ),
              [ShowModalPayment.CONFIRM_DELETE_CREDIT_CARD_PAYMENT]: (
                <ConfirmDeleteCreditCardContent
                  onCancelConfirm={onToggle}
                  onOkConfirm={onDeleteCreditCard}
                />
              ),
              [ShowModalPayment.PAYMENT_ERROR]: (
                <PaymentErroContent
                  messageError={messageError}
                  onOkConfirm={() => {
                    onToggle();
                    onSendOrder();
                  }}
                />
              ),
              [ShowModalPayment.PAYMENT_NOTMADE]: (
                <PaymentNotMadeContent messagePayment={messagePayment} onOkConfirm={onToggle} />
              ),
              [ShowModalPayment.NO_CARD]: <NoCardContent goAddCard={onAddCard} />,
            }[shouldShowModal]
          }
        </Modal>
      </div>
    </AuthWrapper>
  );
};
